import { Component, OnInit } from '@angular/core';
import * as Highcharts from "highcharts";
import HC_more from "highcharts/highcharts-more";
import exporting from 'highcharts/modules/exporting';
import { ReportCountByType } from "../../../../models/analytics.model";
import { AnalyticsService } from '../../../../services/analytics.service';
import { LookupService } from '../../../../services/lookups/lookup.service';
HC_more(Highcharts);
exporting(Highcharts);
@Component({
  selector: 'app-report-count-by-type-card',
  templateUrl: './report-count-by-type-card.component.html',
  styleUrls: ['./report-count-by-type-card.component.css']
})
export class ReportCountByTypeCardComponent implements OnInit {
  
  updateFromInput: boolean = false;
  reportCountByType: ReportCountByType;

  ReportCountByTypeChart: typeof Highcharts = Highcharts; 
  reportCountByTypeChartOptions:any; 

  constructor(private analyticsService: AnalyticsService) { }
  
  ngOnInit() {
  }

  loadChart(yearId:number)
  {
     
   this.analyticsService.getReportCountsByType$(yearId).subscribe((data)=>{
      
      console.log(data);

      this.reportCountByType = data;
      this.reportCountByType.reportYear=data.reportYear
      this.reportCountByType.requiredInternalReportCount = data.requiredInternalReportCount
      this.reportCountByType.requiredPublicReportCount= data.requiredPublicReportCount
      this.reportCountByType.voluntaryInternalReportCount= data.voluntaryInternalReportCount
      this.reportCountByType.voluntaryPublicReportCount =data.voluntaryPublicReportCount
       
    
      this.GetChartOptions();
      this.updateChart();
      
    });

  }


updateChart()
{
  this.updateFromInput = true;
}

GetChartOptions()
  {
    this.reportCountByTypeChartOptions=
    {
    chart: {
        type: 'pie',        
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        width:450,
        height:500,
        options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
        }
    },
    title: {
        text: 'Reports for ' + this.reportCountByType.reportYear,
        style:{"color":"#337ab7","fontSize":"16px","fontWeight":"bold" }
    },
    accessibility: {
        point: {
            valueSuffix: '%'
        }
    },
    tooltip: {
        pointFormat: '{point.percentage:.1f}%'
    },
    plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            depth: 35,
            dataLabels: {
                enabled: false,
                format: '{point.name}'
            },
             size: '80%',
           },            
    },
    credits:{
      enabled:false
    },
    series: [{
        type: 'pie',
        showInLegend: true,
        name: 'Reports share',
        data: [
            {     
                name: 'Required-Public: ' + this.reportCountByType.requiredPublicReportCount,             
                y: this.reportCountByType.requiredPublicReportCount,
                data: this.reportCountByType.requiredPublicReportCount,
                selected: true,
                color:Highcharts.getOptions().colors[7]
             },                             
            { 
                name: 'Required-Internal: ' + this.reportCountByType.requiredInternalReportCount,
                y: this.reportCountByType.requiredInternalReportCount,
                data: this.reportCountByType.requiredInternalReportCount,
                selected: true,
                color:Highcharts.getOptions().colors[8]
            },
             {               
                name: 'Voluntary-Public: ' + this.reportCountByType.voluntaryPublicReportCount,
                y: this.reportCountByType.voluntaryPublicReportCount,
                data: this.reportCountByType.voluntaryPublicReportCount,
                selected: true,
                color: Highcharts.getOptions().colors[3]
            },
             {                
                name: 'Voluntary-Internal: ' + this.reportCountByType.voluntaryInternalReportCount,
                y: this.reportCountByType.voluntaryInternalReportCount,
                data: this.reportCountByType.voluntaryInternalReportCount,
                selected: true,
                color: Highcharts.getOptions().colors[2] 
            }
        ]
    }]
    };

  }
}  



// WEBPACK FOOTER //
// ./src/app/admin/reports-dashboard/dashboard/report-count-by-type-card/report-count-by-type-card.component.ts